<div class="row m-3 p-3">
    <div class="row">
        <div class="d-flex flex-column mb-4">
            <h1 *ngIf="data" class="sub-header-title">
                Delete Data: {{ reservation_reference_id }}
            </h1>
            <h1 *ngIf="!data" class="sub-header-title">
                Delete All Data
            </h1>
        </div>
    </div>
    <div class="mb-3">
        Are you sure you want to proceed?
    </div>
    <div class="mt-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="warn-button" (click)="onConfirmClick()">
            <mat-icon>delete</mat-icon>
            Delete
        </button>
    </div>
</div>